import React from "react";
import { Button, Modal } from "antd";
import CustomInput from "components/General/CustomInput";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Representation = ({
  setPhoneNumberId,
  setBusinessAccountId,
  setPermanentToken,
  onSubmit,
  showModal,
  setShowModal,
}) => {
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const { t } = useTranslation();

  const ModalStyle = {
    padding: "45px",
    borderRadius: "15px",
    background: theme === "dark" ? "#1C193B" : "#ffffff",
    overflow: "hidden",
  };
  return (
    <Modal
      open={showModal}
      bodyStyle={ModalStyle}
      footer={null}
      onCancel={() => setShowModal(false)}
      style={{ overflow: "hidden", borderRadius: "15px", padding: "0px" }}
    >
      <CustomInput
        label={t("settings.339")}
        placeholder={t("settings.340")}
        onChange={setPhoneNumberId}
        style={{ margin: "25px 0px" }}
      />
      <CustomInput
        label={t("settings.341")}
        placeholder={t("settings.342")}
        onChange={setBusinessAccountId}
        style={{ margin: "25px 0px" }}
      />
      <CustomInput
        label={t("settings.343")}
        placeholder={t("settings.344")}
        onChange={setPermanentToken}
        password
        style={{ margin: "25px 0px" }}
      />
      <div className={styles.row}>
        <Button
          className={`${styles.btn} ${styles.outlined}`}
          onClick={() =>
            window.open(
              "https://developers.facebook.com/docs/whatsapp/cloud-api/get-started",
              "_blank"
            )
          }
        >
          {" "}
          {t("settings.101")}
        </Button>
        <Button className={styles.btn} onClick={onSubmit}>
          {" "}
          {t("button.4")}{" "}
        </Button>
      </div>
    </Modal>
  );
};

export default Representation;
